import type { App, Plugin } from 'vue'
import { mergeSettingsConfig, type SettingsPluginOptions } from './config'
import { SETTINGS_CONFIG_KEY } from './composables/useSettingsConfig'
import { createSettingsRoutes } from './router'

export function createSettingsPlugin(options: SettingsPluginOptions): Plugin {
  return {
    install(app: App) {
      const config = mergeSettingsConfig(options.router, options)

      app.provide(SETTINGS_CONFIG_KEY, config)

      const settingsRoutes = createSettingsRoutes(config)
      settingsRoutes.forEach((route) => {
        if (config.parentRouteName) {
          config.router.addRoute(config.parentRouteName, route)
        } else {
          config.router.addRoute(route)
        }
      })

      if (import.meta.env.DEV) {
        console.log('[Settings Plugin] Installed with config:', {
          features: config.features,
          basePath: config.basePath,
          parentRouteName: config.parentRouteName,
        })
        console.log('[Settings Plugin] Registered routes:')
        config.router.getRoutes().forEach((route: any) => {
          if (route.name && route.name.toString().startsWith('settings:')) {
            console.log(`  ${route.name}: ${route.path}`)
          }
        })
      }
    },
  }
}

export type { SettingsPluginOptions } from './config'
